import type { BlogListSort } from "./list-filters";
import { buildBlogCategoryPath } from "./category-routes";
import { blogLocaleFromPathname } from "./locales";

export type BuildBlogQueryHrefParams = {
  q?: string;
  category?: string;
  sort?: BlogListSort;
  page?: number;
};

export function buildBlogQueryHref(
  baseHref: string,
  params: BuildBlogQueryHrefParams,
): string {
  const search = new URLSearchParams();
  const q = params.q?.trim();
  if (q) search.set("q", q);
  const pathname = params.category ? buildBlogCategoryPath(baseHref, params.category, blogLocaleFromPathname(baseHref) ?? "en") : baseHref;
  if (params.sort && params.sort !== "newest") search.set("sort", params.sort);
  if (params.page && params.page > 1) search.set("page", String(params.page));

  const query = search.toString();
  return query ? `${pathname}?${query}` : pathname;
}
